import { FormatDate } from "../../_objects/format-date";
import { TENANT_ROLE, TenantConfig, UserConfig } from "../../app.constants";
import { FILE_SYSTEM } from "../electron.constants";
import { IIndividualReportTemplateSchema } from "../models/individual-report-template.schema";
import { ILoggedInUserSchema } from "../models/logged-in-user.schema";
import { IMarkSchema } from "../models/mark.schema";
import { SubjectAttributesSchema } from "../models/subject-attributes.schema";
import { ISubjectSchema } from "../models/subject.schema";
import { ISubjectModelLocationsSchema } from "../models/subjectModel-locations.schema";
import { ISubjectModelSchema } from "../models/subjectModel.schema";
import { ITenantDetailSchema } from "../models/tenant-detail.schema";
import { ITenantConfigSchema } from "../models/tenantConfiguration.schema";
import { ITitleSchema } from "../models/title.schema";
import { IUserProfileSchema } from "../models/user-profile.schema";
import { IUserSchema } from "../models/user.schema";
import { IUserConfigSchema } from "../models/userConfiguration.schema";
import { REPORT_TEMPLATE_4x2_LAYOUT } from "../templates/report-template-4x2-layout";
import { REPORT_TEMPLATE_4x3_LAYOUT } from "../templates/report-template-4x3-layout";
import { AVIATION_ENGINE_LOCATIONS } from "./aviation_engine_locations";
import { INDUSTRIAL_GAS_TURBINE_LOCATIONS } from "./industrial_gas_turbine_locations";
import { WIND_TURBINE_GEARBOX_LOCATIONS } from "./wind_turbine_gearbox_locations";

/* eslint-disable @typescript-eslint/no-namespace */
export namespace STANDALONE {
  export const ASSETS_PATH: string = "assets/offline/standalone";
  export const AVIATION_ENGINE_ZIP: string = "Aviation Engine/Aviation Engine.zip";
  export const INDUSTRIAL_GAS_TURBINE_ZIP: string = "Industrial Gas Turbine/Industrial Gas Turbine.zip";
  export const WIND_TURBINE_GEARBOX_ZIP: string = "Wind Turbine Gearbox/Wind Turbine Gearbox.zip";

  export const TENANT_ID: string = "tenantxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const USER_ID: string = "userxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const USER_GIVEN_NAME: string = "IPLEX";
  export const USER_SUR_NAME: string = "User";
  export const DISPLAY_NAME: string = "IPLEX User";
  export const AVIATION_ENGINE_SUBJECT_MODEL_ID: string = "mdxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID: string = "gdxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID: string = "wdxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const SUBJECT_VERSION: number = 1;
  export const AVIATION_ENGINE_SUBJECT_ID: string = "sbxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const INDUSTRIAL_GAS_TURBINE_SUBJECT_ID: string = "gbxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const WIND_TURBINE_GEARBOX_SUBJECT_ID: string = "wbxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const MARK_ID: string = "mkxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const TITLE_ID: string = "tlxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const INDIVIDUAL_REPORT_TEMPLATE_ID_1: string = "tp01xxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
  export const INDIVIDUAL_REPORT_TEMPLATE_ID_2x2: string = "8370127d-c56a-488a-b00c-f5858ea74735";
  export const INDIVIDUAL_REPORT_TEMPLATE_ID_2x3: string = "2a230a52-0361-412f-9bc8-c7fe818e4766";
  export const INDIVIDUAL_REPORT_TEMPLATE_ID_4x2: string = "0c0219f1-d733-4b6d-beda-e72e3e99aa7f";
  export const INDIVIDUAL_REPORT_TEMPLATE_ID_4x3: string = "46e5d217-1164-4604-a123-c5df89eb49f9";
  export const SCHEMA_VERSION: string = "1";
  export const INITIALIZED_DATE_TIME: string = new FormatDate().toString();

  export const TENANT_DETAIL_DATA: ITenantDetailSchema = {
    id: TENANT_ID,
    name: null
  };

  export const TENANT_CONFIG_DATA: Array<ITenantConfigSchema> = [
    {
      key: TenantConfig.IsEnabledAnalytics.KEY,
      value: "true",
      valueType: "boolean",
      groupKey: "EnableAdvancedFeatures",
      selectItems: `[{"label":"No","value":false},{"label":"Yes","value":true}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.ImageSelectModeWhenCreatingReport.KEY,
      value: "2",
      valueType: "number",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"No","value":0},{"label":"Yes","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.IsSelectedAllFolderWhenCreatingReport.KEY,
      value: "false",
      valueType: "boolean",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"No","value":false},{"label":"Yes","value":true}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.DefaultMarkWhenUploadingNoMarkImage.KEY,
      value: "0",
      valueType: "number",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"A","value":1},{"label":"B","value":2},{"label":"C","value":3},{"label":"D","value":4},{"label":"E","value":5},{"label":"X","value":0}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.DefaultUnitOfMeasurementResult.KEY,
      value: "0",
      valueType: "number",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"mm","value":0},{"label":"inch","value":1}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.DefaultImageQualityOfFinalReports.KEY,
      value: "1",
      valueType: "number",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"High","value":0},{"label":"Medium","value":1},{"label":"Low","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.DefaultImageQualityOfDraftReports.KEY,
      value: "2",
      valueType: "number",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"High","value":0},{"label":"Medium","value":1},{"label":"Low","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.ShowTagsOnImages.KEY,
      value: "false",
      valueType: "boolean",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"No","value":false},{"label":"Yes","value":true}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.InspectionStructureFormat.KEY,
      value: "0",
      valueType: "number",
      groupKey: "SwitchApplicationBehavior",
      selectItems: `[{"label":"Legacy","value":0},{"label":"Tree","value":1}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.SubjectAttributeOwner.KEY,
      value: "2",
      valueType: "number",
      groupKey: "AdditionalAttribute",
      selectItems: `[{"label":"Hide","value":0},{"label":"Required","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.SubjectAttributeCountry.KEY,
      value: "2",
      valueType: "number",
      groupKey: "AdditionalAttribute",
      selectItems: `[{"label":"Hide","value":0},{"label":"Required","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.SubjectAttributeState.KEY,
      value: "2",
      valueType: "number",
      groupKey: "AdditionalAttribute",
      selectItems: `[{"label":"Hide","value":0},{"label":"Required","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.SubjectAttributeDistrict.KEY,
      value: "2",
      valueType: "number",
      groupKey: "AdditionalAttribute",
      selectItems: `[{"label":"Hide","value":0},{"label":"Required","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.SubjectAttributeSite.KEY,
      value: "2",
      valueType: "number",
      groupKey: "AdditionalAttribute",
      selectItems: `[{"label":"Hide","value":0},{"label":"Required","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.SubjectAttributeProject.KEY,
      value: "2",
      valueType: "number",
      groupKey: "AdditionalAttribute",
      selectItems: `[{"label":"Hide","value":0},{"label":"Required","value":1},{"label":"Optional","value":2}]`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfMark.KEY,
      value: "Mark",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfTitle.KEY,
      value: "Title",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfOwner.KEY,
      value: "Owner",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfCountry.KEY,
      value: "Country",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfState.KEY,
      value: "State",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfRegion.KEY,
      value: "Region",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfSite.KEY,
      value: "Site",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfProject.KEY,
      value: "Project",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfSerialNumber.KEY,
      value: "S/N",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    },
    {
      key: TenantConfig.LabelOfTags.KEY,
      value: "Tags",
      valueType: "string",
      groupKey: "DefineTerminology",
      selectItems: `null`,
      tenantId: TENANT_ID
    }
  ];

  /** User データ。 */
  export const USER_DATA: IUserSchema = {
    id: USER_ID,
    givenName: USER_GIVEN_NAME,
    surname: USER_SUR_NAME,
    tenantId: TENANT_ID,
    email: null,
    telephoneNumber: null,
    isActive: true,
    isSubscription: true
  };

  /** User Profile データ。 */
  export const USER_PROFILE_DATA: IUserProfileSchema = {
    id: USER_ID,
    tenantId: TENANT_ID,
    displayName: DISPLAY_NAME,
    givenName: USER_GIVEN_NAME,
    surname: USER_SUR_NAME,
    role: TENANT_ROLE.ADMIN,
    identityProviderType: 1,
    isAppAdmin: true
  };

  /** Logged In User データ。 */
  export const LOGGED_IN_USER_DATA: ILoggedInUserSchema = {
    id: USER_ID,
    givenName: USER_GIVEN_NAME,
    surname: USER_SUR_NAME,
    initials: USER_GIVEN_NAME.substring(0, 1) + USER_SUR_NAME.substring(0, 1),
    isAgreedTerms: false,
    accountEnabled: true,
    country: null,
    schemaVersion: SCHEMA_VERSION,
    tenantAttributes: `[{ "id": "${TENANT_ID}", "name": "", "role": "${TENANT_ROLE.ADMIN}", "isDefault": true }]`,
    currentNetworkMode: false,
    lastLoggedInDate: INITIALIZED_DATE_TIME,
    tenantId: TENANT_ID
  };

  /** Subject Model データ。 */
  export const AVIATION_ENGINE_SUBJECT_MODEL_DATA: ISubjectModelSchema = {
    id: AVIATION_ENGINE_SUBJECT_MODEL_ID,
    name: "Aviation Engine",
    structImageFilePath: `subjectModels/${AVIATION_ENGINE_SUBJECT_MODEL_ID}/images/struct.jpg`,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    isValid: true,
    tenantId: TENANT_ID,
    isDeleted: false,
    subjects: [],
    subjectModelLocations: [],
    // TODO: IPLEX Mode 初期データはオンラインで作成したデータと同じ扱いにする。
    isOfflineData: false
  };

  export const INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_DATA: ISubjectModelSchema = {
    id: INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID,
    name: "Industrial Gas Turbine",
    // no image for the moment
    structImageFilePath: null,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    isValid: true,
    tenantId: TENANT_ID,
    isDeleted: false,
    subjects: [],
    subjectModelLocations: [],
    isOfflineData: false
  };

  export const WIND_TURBINE_GEARBOX_SUBJECT_MODEL_DATA: ISubjectModelSchema = {
    id: WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID,
    name: "Wind Turbine Gearbox",
    // no image for the moment
    structImageFilePath: null,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    isValid: true,
    tenantId: TENANT_ID,
    isDeleted: false,
    subjects: [],
    subjectModelLocations: [],
    isOfflineData: false
  };

  /** Subject Model locations データ。 */
  export const AVIATION_ENGINE_SUBJECT_MODEL_LOCATIONS_DATA: ISubjectModelLocationsSchema = {
    id: `${AVIATION_ENGINE_SUBJECT_MODEL_ID}_${SUBJECT_VERSION}`,
    subjectModelId: AVIATION_ENGINE_SUBJECT_MODEL_ID,
    version: SUBJECT_VERSION,
    locations: JSON.stringify(AVIATION_ENGINE_LOCATIONS),
    isNewestVersion: true,
    subjectModel: null
  };

  export const INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_LOCATIONS_DATA: ISubjectModelLocationsSchema = {
    id: `${INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID}_${SUBJECT_VERSION}`,
    subjectModelId: INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID,
    version: SUBJECT_VERSION,
    locations: JSON.stringify(INDUSTRIAL_GAS_TURBINE_LOCATIONS),
    isNewestVersion: true,
    subjectModel: null
  };

  export const WIND_TURBINE_GEARBOX_SUBJECT_MODEL_LOCATIONS_DATA: ISubjectModelLocationsSchema = {
    id: `${WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID}_${SUBJECT_VERSION}`,
    subjectModelId: WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID,
    version: SUBJECT_VERSION,
    locations: JSON.stringify(WIND_TURBINE_GEARBOX_LOCATIONS),
    isNewestVersion: true,
    subjectModel: null
  };

  /** Subject データ。 */
  export const AVIATION_ENGINE_SUBJECT_DATA: ISubjectSchema = {
    schemaVersion: SCHEMA_VERSION,
    tenantId: TENANT_ID,
    createdBy: USER_ID,
    lastUpdatedBy: USER_ID,
    id: AVIATION_ENGINE_SUBJECT_ID,
    serialNo: "AE_0001",
    subjectModelId: AVIATION_ENGINE_SUBJECT_MODEL_ID,
    owner: null,
    country: null,
    state: null,
    district: null,
    site: null,
    project: null,
    isValid: true,
    createDate: INITIALIZED_DATE_TIME,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    isDeleted: false,
    isOfflineData: false,
    inspections: [],
    subjectModel: null
  };

  export const INDUSTRIAL_GAS_TURBINE_SUBJECT_DATA: ISubjectSchema = {
    schemaVersion: SCHEMA_VERSION,
    tenantId: TENANT_ID,
    createdBy: USER_ID,
    lastUpdatedBy: USER_ID,
    id: INDUSTRIAL_GAS_TURBINE_SUBJECT_ID,
    serialNo: "IGT_0001",
    subjectModelId: INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID,
    owner: null,
    country: null,
    state: null,
    district: null,
    site: null,
    project: null,
    isValid: true,
    createDate: INITIALIZED_DATE_TIME,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    isDeleted: false,
    isOfflineData: false,
    inspections: [],
    subjectModel: null
  };

  export const WIND_TURBINE_GEARBOX_SUBJECT_DATA: ISubjectSchema = {
    schemaVersion: SCHEMA_VERSION,
    tenantId: TENANT_ID,
    createdBy: USER_ID,
    lastUpdatedBy: USER_ID,
    id: WIND_TURBINE_GEARBOX_SUBJECT_ID,
    serialNo: "WTG_0001",
    subjectModelId: WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID,
    owner: null,
    country: null,
    state: null,
    district: null,
    site: null,
    project: null,
    isValid: true,
    createDate: INITIALIZED_DATE_TIME,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    isDeleted: false,
    isOfflineData: false,
    inspections: [],
    subjectModel: null
  };

  /** Subject Attributes データ。 */
  export const AVIATION_ENGINE_SUBJECT_ATTRIBUTES_DATA: SubjectAttributesSchema = {
    id: `${AVIATION_ENGINE_SUBJECT_ID}_${SUBJECT_VERSION}`,
    subjectId: AVIATION_ENGINE_SUBJECT_ID,
    version: SUBJECT_VERSION,
    owner: null,
    country: null,
    state: null,
    district: null,
    site: null,
    project: null,
    isNewestVersion: true,
    subject: null
  };

  export const INDUSTRIAL_GAS_TURBINE_SUBJECT_ATTRIBUTES_DATA: SubjectAttributesSchema = {
    id: `${INDUSTRIAL_GAS_TURBINE_SUBJECT_ID}_${SUBJECT_VERSION}`,
    subjectId: INDUSTRIAL_GAS_TURBINE_SUBJECT_ID,
    version: SUBJECT_VERSION,
    owner: null,
    country: null,
    state: null,
    district: null,
    site: null,
    project: null,
    isNewestVersion: true,
    subject: null
  };

  export const WIND_TURBINE_GEARBOX_SUBJECT_ATTRIBUTES_DATA: SubjectAttributesSchema = {
    id: `${WIND_TURBINE_GEARBOX_SUBJECT_ID}_${SUBJECT_VERSION}`,
    subjectId: WIND_TURBINE_GEARBOX_SUBJECT_ID,
    version: SUBJECT_VERSION,
    owner: null,
    country: null,
    state: null,
    district: null,
    site: null,
    project: null,
    isNewestVersion: true,
    subject: null
  };

  /** Mark データ。 */
  export const MARK_DATA: IMarkSchema = {
    tenantId: TENANT_ID,
    id: MARK_ID,
    items: `[{"identifier": 1,"code": "A","label": "Accepted","color": "#00ff00"},{"identifier": 2,"code": "B","label": "Review Minor","color": "#ffff00"},{"identifier": 3,"code": "C","label": "Review Major","color": "#ffa500"},{"identifier": 4,"code": "D","label": "Rejected","color": "#ff0000"},{"identifier": 0,"code": "X","label": "No Mark","color": "#ffffff00"}]`,
    isDeleted: false,
    isValid: true,
    createDate: INITIALIZED_DATE_TIME,
    createdBy: USER_ID,
    lastUpdateDate: INITIALIZED_DATE_TIME,
    lastUpdatedBy: USER_ID,
    schemaVersion: SCHEMA_VERSION
  };

  /** Title データ。 */
  export const TITLE_DATA: ITitleSchema = {
    tenantId: TENANT_ID,
    id: TITLE_ID,
    items: `[{"identifier":"BURNING"},{"identifier":"CRACKED"},{"identifier":"DENTED"},{"identifier":"EROSION"},{"identifier":"FOREIGN OBJECT SPLATTER"},{"identifier":"IMPACT DAMAGE"},{"identifier":"LOSS OF MATERIAL"},{"identifier":"MISSING"},{"identifier":"NICK"},{"identifier":"NICK WITH TEAR"},{"identifier":"OIL SOAKED"},{"identifier":"PITTING & FLAKING"},{"identifier":"SEVERE DAMAGE"},{"identifier":"TIP DAMAGE"},{"identifier":"TIP RELEASE"},{"identifier":"AMM LIMITS"},{"identifier":"OTHER DAMAGE"}]`,
    isDeleted: false,
    isValid: true,
    createDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    schemaVersion: SCHEMA_VERSION
  };

  /** Individual Report Templates データ。 */
  export const INDIVIDUAL_REPORT_TEMPLATE_DATA: Array<IIndividualReportTemplateSchema> = [
    {
      id: INDIVIDUAL_REPORT_TEMPLATE_ID_4x2,
      name: "Report Template 4x2 Layout",
      subjectModelIds: `[ "${AVIATION_ENGINE_SUBJECT_MODEL_ID}", "${INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID}", "${WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID}" ]`,
      assetTypeIds: `[ "${AVIATION_ENGINE_SUBJECT_MODEL_ID}", "${INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID}", "${WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID}" ]`,
      schemaVersion: SCHEMA_VERSION,
      template: REPORT_TEMPLATE_4x2_LAYOUT,
      isValid: true,
      reportTitleInputMode: "0",
      reportTitleFormat: "[]",
      createdBy: USER_ID,
      createDate: INITIALIZED_DATE_TIME,
      lastUpdatedBy: USER_ID,
      lastUpdateDate: INITIALIZED_DATE_TIME,
      tenantId: TENANT_ID,
      imagePathList: `[{"id":"preview.pdf","src":"${FILE_SYSTEM.PATH.REPORT_TEMPLATE}/${INDIVIDUAL_REPORT_TEMPLATE_ID_4x2}/preview/preview.pdf"}]`,
      isDeleted: false,
      isOfflineData: false
    },
    {
      id: INDIVIDUAL_REPORT_TEMPLATE_ID_4x3,
      name: "Report Template 4x3 Layout",
      subjectModelIds: `[ "${AVIATION_ENGINE_SUBJECT_MODEL_ID}", "${INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID}", "${WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID}" ]`,
      assetTypeIds: `[ "${AVIATION_ENGINE_SUBJECT_MODEL_ID}", "${INDUSTRIAL_GAS_TURBINE_SUBJECT_MODEL_ID}", "${WIND_TURBINE_GEARBOX_SUBJECT_MODEL_ID}" ]`,
      schemaVersion: SCHEMA_VERSION,
      template: REPORT_TEMPLATE_4x3_LAYOUT,
      isValid: true,
      reportTitleInputMode: "0",
      reportTitleFormat: "[]",
      createdBy: USER_ID,
      createDate: INITIALIZED_DATE_TIME,
      lastUpdatedBy: USER_ID,
      lastUpdateDate: INITIALIZED_DATE_TIME,
      tenantId: TENANT_ID,
      imagePathList: `[{"id":"preview.pdf","src":"${FILE_SYSTEM.PATH.REPORT_TEMPLATE}/${INDIVIDUAL_REPORT_TEMPLATE_ID_4x3}/preview/preview.pdf"}]`,
      isDeleted: false,
      isOfflineData: false
    }
  ];

  export const USER_CONFIG_DATA: Array<IUserConfigSchema> = [
    {
      key: UserConfig.IsEnabledDarkMode.KEY,
      value: "true",
      valueType: "boolean",
      groupKey: null,
      selectItems: JSON.stringify([]),
      userId: USER_ID,
      tenantId: TENANT_ID
    }
  ];
}
